import React, { useEffect, useState } from "react";
import { Row, Col, Rate, Input, Pagination, Spin } from "antd";
import JobCard from "../../components/JobCard/JobCard";
import { Menu, Dropdown, message } from "antd";
import { BsSortUpAlt } from "react-icons/bs";
import { SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import candidate_img from "../../assets/img/becomeACandidate.png";
import { getImageByStateCode } from "../CompanyProfile/components/cloudinary";
import "./MyMatches.css";
import { getMatches, getMatchesSort } from "../../redux/actions";
import Loader from "../../components/Loading/Loader";
import FeatureGate from "../FeatureGate/FeatureGate";
import closeIcon from "../../assets/icons/clarity_window-closeLine.svg";
import TopAlert from "../../components/TopNotification/TopAlert";
import emptyjobs from "../../assets/img/Emptyjobs.png"
import MobilePagination from "../../components/Pagination/MobilePagination";
import { canUseSubscriptionFeatures } from "../../shared/billing";

export default function MyMatches() {
  const subscriptionFeaturesEnabled = canUseSubscriptionFeatures();
  const dispatch = useDispatch();
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const creditsBalanceLoaded = useSelector((state) => state.plansReducer?.creditsBalanceLoaded);
  const [sorttype, setsorttype] = useState("most_recent");
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [pageSize, setPageSize] = useState("24");
  const [currentPage, setCurrentPage] = useState(1);
  const [inputSearch, setInputSearch] = useState("");
  const [searchPublish, setsearchPublish] = useState([]);

  const loading = useSelector((state) => state.getMatchesReducer.loading);
  const details = useSelector((state) => state.getMatchesReducer.details);
  const deljobsuccess = useSelector(
    (state) => state.manageJobsReducer.del_success
  );
  const delete_job_response = useSelector(
    (state) => state.manageJobsReducer.response
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  useEffect(() => {
    dispatch(
      getMatches({
        currentPage,
        pageSize,
        sorttype: sorttype,
      })
    );
  }, [currentPage, sorttype]);

  // useEffect(() => {
  //   dispatch(
  //     getMatchesSort({
  //       sorttype: sorttype,
  //     })
  //   );
  // }, [sorttype, deljobsuccess]);

  useEffect(() => {
    if (details.length !== 0) {
      setsearchPublish(details?.publishedGigs);
    }
  }, [details]);

  const onClick = ({ key }) => {
    if (key == "most_recent") {
      setsorttype("most_recent");
    } else {
      setsorttype("upcoming_expiry");
    }
  };

  const menu = (
    <Menu onClick={onClick}>
      <Menu.Item key="most_recent">Most Recent</Menu.Item>
      <Menu.Item key="upcoming_expiry">Upcoming Expiry</Menu.Item>
    </Menu>
  );

  const searchHandler = (searchText) => {
    setInputSearch(searchText);
    var search = details?.publishedGigs.filter((item) =>
      item.Title.toLowerCase().includes(searchText.toLowerCase())
    );
    if (searchText === "") {
      setsearchPublish(details?.publishedGigs);
    } else {
      setsearchPublish(search);
    }
  };

  const onChangePage = (page, pageSize) => {
    setCurrentPage(page); 
  };

  if (subscriptionFeaturesEnabled && !creditsBalanceLoaded) return <Loader />;
  if (subscriptionFeaturesEnabled && creditsBalance?.data?.status === 'expired') return (
    <FeatureGate
      featureName="My Matches"
      iconType="candidate"
      description="Your plan has expired. You cannot view your matched candidates. Choose a plan to continue accessing your matches."
      bottomText="My Matches is a paid feature and was given to you for free during your trial period."
    />
  );

  return (
    <div className="myMacthes-container"
    >
      {/* {deljobsuccess && delete_job_response.status == 200 ? (
          <TopAlert display={"flex"} title={"Job deleted successfully"} type="success" />
        ) : null} */}

      {deljobsuccess && delete_job_response.status == 500 ? (
        <TopAlert
          display={"flex"}
          title={delete_job_response.message}
          type="warning"
        />
      ) : null}
      <Row justify={"space-between"} style={{ padding: "0px" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span className="My-Matches">My Matches</span>

          <span className="-items">{details?.total_count} item{details?.total_count > 1 && 's'}</span>
        </div>
        {searchPublish.length !== 0 && (
        windowDimensions.width > 844 ? (
          <Dropdown overlay={menu}>
            <BsSortUpAlt className="myMatches-sorticon" />
          </Dropdown>
        ) : null )}
      </Row>
      {details?.total_count !== 0 && (
      <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between" }}>
        <Input
          className="search-bar"
          type="input"
          placeholder="Search"
          onChange={(e) => {
            searchHandler(e.target.value);
          }}
          value={inputSearch}
          prefix={<SearchOutlined className="myMatches-searchicon" />}
          suffix={
            inputSearch.length > 0 ? (
              <img
                src={closeIcon}
                style={{}}
                alt=""
                onClick={(e) => {
                  setInputSearch("");
                  setsearchPublish(details?.publishedGigs);
                }}
              />
            ) : null
          }
        />
        {searchPublish.length !== 0 && (
        windowDimensions.width <= 844 ? (
          <Dropdown overlay={menu}>
            <BsSortUpAlt className="myMatches-sorticon" />
          </Dropdown>
        ) : null )}
      </div>)}
      
      <Row
        gutter={[16, 16]}
        justify={"flex-start"}
        style={{ marginTop: "18px" }}
      >
        {loading ? (
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Loader />
          </div>
        ) : searchPublish.length !== 0 ? (
          searchPublish.map((items, index) => {
           
            return (
                <Col xs={24} lg={8} key={index}>
                  <JobCard
                    {...(items||{})}
                    jobdetails ={[items]}
                    id={items.JobOrderId}
                    JobOrderId={items.JobOrderId}
                    key={items._id}
                    img={
                      items?.Regions?.Code !== null &&
                      items?.Cities?.CityName !== null
                        ? getImageByStateCode(
                            items?.Regions?.Code,
                            items?.Cities?.CityName,
                            items?.CompanyName
                          )
                        : // "BU",
                          // "Burwell"

                          candidate_img
                    }
                    RegionCode={items?.Regions?.Code}
                    CityName={items?.Cities?.CityName}
                    // location={items?.Countries?.CountryName}
                    location={`${items?.Cities?.CityName}, ${items?.Regions?.Code}`}
                    professionCode={userProfile?.Professions?.ProfessionCode}
                    title={items.Title}
                    facilityname={items.FacilityName}
                    facilityRating = {items.facilityRating}
                    budget={items.BudgetMin}
                    rates={items?.BudgetTypes?.BudgetTypeName}
                    RoleName={items?.Role}
                    experience={items.ExperienceLevels}
                    matchedbids={items.status[2].count}
                    cardFooter={true}
                    placedbids={items.status[0].count}
                    receivedbids={items.status[1].count}
                    candidates={items.status[3].count}
                    BudgetMin={items.BudgetMin}
                    fromDashboard={false}
                    Skills={items?.JobOrders_Skills}
                    Industry={items?.Industry}
                    jobOrderType={items?.JobOrderTypes?.JobOrderTypeName}
                    WorkplacePolicy={items?.WorkplacePolicy}
                    description={items?.Description}
                    workauthorization={items?.WorkAuthorization}
                    certificates={items?.Certifications}
                    IdealContractLengthName={items?.IdealContractLength?.IdealContractLengthName}
                    from={"MyMatches"}
                    rating={items?.facilityRating?.rating}
                    created={items?.Created}
                  />
                </Col>
            );
          })
        ) : 
        <div  style={{ display: "flex", justifyContent: "center", width: "100%" }}
         className="noJobsContainer">

                  <img
                    src={emptyjobs}
                    alt="no-jobsimg"
                    className="joblisting-noimg"
                    style={{ width: "15rem", height: "9.3rem" }}
                  ></img>

                  <div className="joblisting-noimg">You have no matched candidates</div>
        </div>}
      </Row>
      {searchPublish.length !== 0 ? (
        windowDimensions.width > 769 ? 
        <Pagination
          className="Pagination-matches"
          total={details.total_count}
          current={currentPage}
          defaultPageSize={pageSize}
          onChange={(page, pageSize) => onChangePage(page, pageSize)}
          hideOnSinglePage={true}
        /> :
        details?.total_count > 20 ? <MobilePagination         
        className="Pagination-matches"
        total={details.total_count}
        current={currentPage}
        defaultPageSize={20}
        onChange={(page) => onChangePage(page, 20)}/> : 
        <div style={{marginTop: "10rem"}}></div> 
        
      ) : <div style={{marginTop: "10rem"}}></div> }
    </div>
  );
}
